import React from 'react';

const Up = () => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.99928 2.82783L2.04928 7.77783L0.635281 6.36383L6.99928 -0.000167847L13.3633 6.36383L11.9493 7.77783L6.99928 2.82783Z"
      fill="#121212"
    />
  </svg>
);

export default Up;
